export default {
  buildingEvents: {
    table: {
      columns: {
        eventName: "Event Name",
        eventSubType: "Event Sub Type",
        eventType: "Event Type",
        toDo: "To Do",
        year: "Year",
      },
    },
  },
  card: {
    ADDRESS: "ADDRESS",
    "ASSET ID": "ASSET ID",
    "ASSET NAME": "ASSET NAME",
    "CO2 EMISSIONS": "CO2 EMISSIONS",
    "ENERGY CONSUMPTION": "ENERGY CONSUMPTION",
    "EPC CLASS": "EPC CLASS",
    "GROSS AREA (INCL. BASEMENT)": "GROSS AREA (INCL. BASEMENT)",
    "GROSS ASSET SIZE": "GROSS ASSET SIZE",
    "GROSS ASSET VALUE": "GROSS ASSET VALUE",
    "MODERNIZATION YEAR": "MODERNIZATION YEAR",
    "Net LETTABLE AREA (WITHOUT BASEMENT)": "Net LETTABLE AREA (WITHOUT BASEMENT)",
    "STRANDING YEAR": "STRANDING YEAR",
    title: "building information",
    TYPE: "TYPE",
    "YEAR OF CONSTRUCTION": "YEAR OF CONSTRUCTION",
  },
  certificateCard: {
    "Allotment date": "Allotment date",
    Area: "Area",
    certificateTitle: "Certificates",
    energyRatingTitle: "EU EPC rating certificates",
    epcTitle: "EPC information",
    "Valid until": "Valid until",
  },
  crremPathway: {
    baseline: "Baseline Emission",
    correctedCo2: "Climate And Grid Corrected Asset Performance",
    correctedKwh: "Asset Energy Intensity",
    emission: "CO₂ Emission",
    incomplete: "The CRREM pathway cannot be shown. Missing required fields: {{fields}}.",
    kwh: "kWh",
    scenario: "Scenario",
    subset: {
      hint: "Download the subset template, adjust values for this building, then upload the Excel file. You can revert to the project defaults at any time.",
      revert: "Revert to project defaults",
      revertConfirm: "This removes your custom subset values and restores the project defaults.",
      tab: "Subset",
      title: "Subset",
    },
    targetCo2: "Decarbonization Target",
    targetKwh: "Country Specific Energy Target",
    year: "Year",
  },
  detailsCard: {
    nav: {
      image: "Image",
      miniMap: "Mini Map",
      threeDModel: "3D Model",
    },
  },
  energyAnalysis: {
    acceptedFormat: "Accepted file format: .xlsx",
    chartTypes: {
      barHorizontal: "Horizontal",
      barVertical: "Bar",
      doughnut: "Doughnut",
      heatmap: "Heatmap",
      kpi: "KPI",
      line: "Line",
      sankey: "Flow",
      stackedBar: "Stacked",
      stackedPercent: "100%",
      sunburst: "Sunburst",
      treemap: "Treemap",
    },
    columns: {
      mix: "Mix",
      share: "Share",
      useType: "Use type",
      utility: "Utility",
      value: "Energy (kWh)",
      year: "Year",
    },
    dimensionInsights: {
      percentTrend: "{{dimension}} composition over time (100%)",
      ranked: "{{dimension}} totals ({{year}})",
      share: "{{dimension}} share ({{year}})",
    },
    downloadTemplate: "Download template",
    energyInput: "Energy input",
    insights: {
      changeDrivers: "What drives the change",
      correctionImpact: "What each correction does",
      correctionScenariosTrend: "All correction scenarios over time",
      correctionWaterfall: "From measured to fully corrected",
      scenarioPerformance: "Scenario performance",
      sourceShare: "Selected metric by source",
      startEndComposition: "Where the selected metric comes from",
      startEndSources: "Source composition: start and end",
    },
    joint: {
      butterfly: "Energy and CO₂ by use-and-utility pair",
      shareScatter: "Energy share vs. CO₂ share",
      trend: "Energy & CO₂ trend",
      yearlyScatter: "Total yearly energy vs. CO₂",
    },
    kpis: {
      activeCombinations: "Active combinations ({{year}})",
      carbonIntensity: "Carbon intensity ({{year}})",
      changeSince: "Change since {{year}}",
      co2Change: "CO₂ change since {{year}}",
      co2ForYear: "CO₂ emissions ({{year}})",
      correctionEffect: "Full correction effect ({{year}})",
      energyForYear: "Energy consumption ({{year}})",
      fullyCorrected: "Fully corrected ({{year}})",
      measured: "Measured baseline ({{year}})",
      pairs: "pairs",
      scenarios: "Correction scenarios",
      topCategoryShare: "Largest category share ({{year}})",
      topCombination: "Top: {{combination}}",
      topCombinationEmpty: "Top combination",
      topCombinationShare: "Top combination share ({{year}})",
      topUseType: "Top use type",
      topUtility: "Top utility",
      totalForYear: "Total ({{year}})",
      variants: "variants",
    },
    mixChartTitle: "Utility × use type",
    mixInsights: {
      changeByEnd: "Change by {{year}}",
      changeMatrix: "Change matrix: {{startYear}} → {{endYear}}",
      combinationTrend: "Selected metric by combination",
      mosaic: "Combination share ({{year}})",
    },
    noDataHint: "Download the template, fill it with this building's energy data, then upload the Excel file.",
    noDataTitle: "No energy data yet",
    openDashboard: "Energy analysis",
    settings: {
      analysis: "Analysis",
      average: "Average",
      climate: "Climate",
      co2: "CO₂",
      corrections: "Correction type",
      coverage: "Coverage",
      grossArea: "Gross area",
      kwh: "Energy (kWh)",
      metric: "Metric",
      netLettableArea: "Net lettable area",
      partitionBy: "Partition by",
      partitionNone: "None",
      regression: "Linear regression",
      scale: "Scale",
      scaleNone: "No",
      snapshotYear: "Snapshot year",
      title: "Settings",
      trendMethod: "Trend method",
      vacancy: "Vacancy",
      yearRange: "Year range",
      yearTo: "to",
    },
    tableTitle: "Data",
    tabs: {
      corrections: "Correction factors",
      joint: "Energy vs CO₂",
      mix: "Use type vs Utility",
      useType: "Use type Analysis",
      utility: "Utility Analysis",
    },
    title: "Energy analysis",
    totalChartTitle: "Breakdown (total)",
    totalKpi: "Total",
    trendChartTitle: "Breakdown trend",
    unit: "kWh",
    upload: "Upload",
    uploadBoxHint: "Download the template, fill it with your energy data, then upload the Excel file.",
  },
  esg: {
    ranks: {
      aboveAverage: "Above Average",
      average: "Average",
      belowAverage: "Below Average",
      buildingType: "Bulding Type",
      quantity: "Quantity",
      top15: "Top 15%",
      top30: "Top 30%",
      unknown: "Unknown",
    },
    table: {
      columns: {
        yourBuilding: "Your Building",
      },
    },
    title: "ESG Index",
  },
  kpis: {
    anticipatedStrandingYear: "Anticipated Stranding year",
    crremM2Gross: "CRREM (m² gross)",
    endEnergyDemand: "End Energy Demand",
    endEnergyDemandReferenceBuilding: "End Energy Demand Reference Building",
    energyEfficiencyClass: "Energy Efficiency Class",
    epcConsumption: "EPC-Consumption",
    geg2024LettableArea: "GEG 2024 (m² lettable area)",
    impactOnEnergyEfficiencyClassNGF: "Expected Impact on Energy Efficiency Class (kWh/m² NGF)",
    kpisNotListed: "KPIs not listed.",
    performanceRatio: "Performance Ratio",
    performanceRatioBetter: "Better",
    performanceRatioBuildingReference: "Building / Reference",
    performanceRatioWorse: "Worse",
    performanceRatioWorstPerformingBadge: "Part of worst performing buildings",
    primaryEnergyConsumption: "Primary Energy Consumption",
    primaryEnergyDemand: "Primary Energy Demand",
    primaryEnergyDemandReferenceBuilding: "Primary Energy Demand Reference Building",
    title: "KPIs",
    totalCarbonEmission: "total carbon emission",
    totalEnergyConsumption: "total energy consumption",
  },
  table: {
    columns: {
      "date modified": "date modified",
      files: "files",
      name: "name",
      type: "type",
    },
    downloadAllFiles: "Download all files",
    fileSections: {
      "3D Models": "3D Models",
      "Building Plans": "Building Plans",
      Document: "Document",
      fileSection: "File Section",
      Other: "Other",
      Reports: "Reports",
    },
    title: "Building passport files",
  },
};
